<template>
  <div> 
    <div id="contact-info" class="contact-info" data-aos="fade" data-aos-delay="0">

    <div class="imgl" data-aos="zoom-in" data-aos-delay="0" >
      <div>
    <img src="@/projects/smilecastle/all/f6.png" class="f6" />
    <img src="@/projects/smilecastle/all/f2.png" class="f2" />
    <img src="@/projects/smilecastle/all/f3.png" class="f3" />
    <img src="@/projects/smilecastle/all/f5.png" class="f5" />
    <img src="@/projects/smilecastle/all/f1.png" class="f1" /></div>
    </div>
   <div class="imgr" data-aos="zoom-in" data-aos-delay="0"><div>
    <img src="@/projects/smilecastle/all/f3.png" class="f3" />
    <img src="@/projects/smilecastle/all/f3.png" class="f5" />
    <img src="@/projects/smilecastle/all/f2.png" class="f2" />
    <img src="@/projects/smilecastle/all/f4.png" class="f4" />
    <img src="@/projects/smilecastle/all/f1.png" class="f1" /></div>
    </div>

    <!--  <img class="logo" src="@/assets/img/contact-logo.png" :alt="info.caseName" data-aos="fade-down" data-aos-delay="0" /> --> 
 <svg class="logo" data-aos="zoom-in" data-aos-delay="200" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 626 178">
<path d="M279.3,143.3c-15-10.9-30.4-23.8-42.3-39c-8.7,16.1-23.7,29.9-39.1,39h-34.7c25-9.3,54.4-26.5,62.3-49.6h-58.7V82.6h61.5c1.3-5.2,1.8-13.7,1.6-19.8c-16.5,0.5-40.9,1-54.7,1.1V52.2c26.8,0.5,99.4-2.3,124.2-5.7v11.7c-13.6,1.3-40.9,3.3-54.4,3.9c0.2,5.5-0.6,14.5-1.5,20.5h63.6v11.1h-66.2c-0.2,1.3-0.8,3.7-1.6,5h11.6c16.5,19.4,37.1,33.7,58.2,44.6H279.3z M216.5,22.9c2,7.2,5.6,14.5,9,21h-16c-3.1-6.8-6.2-13.8-8.3-21h-8C189.9,31,186,38.8,181,46.1h-17.3C173.2,32,179.6,17,184.3,0.8h16.3c-0.8,3.1-2.3,7.6-3.6,10.6h39.9v11.5H216.5L216.5,22.9z M282.2,22.9c2.6,7.3,6.2,14.5,10.6,21h-17.3c-3.6-6.8-6.9-13.7-9.1-21h-9c-4.1,7.6-8.8,16.4-14.5,23.3h-18.3c13.1-13,19.6-29.1,25.8-45.4H266c-1,3.3-2.6,7.8-3.8,10.6H308v11.5H282.2L282.2,22.9z M371.5,68.3h-19.1c-2,0-3.3-1.1-3.3-3.3V45.2h-14.4v21.3c-0.1,6.9,5.2,12.8,12.6,12.7h24.2v13.5h-43.6v10.9h10.8c1.1,12.2-0.6,28.5-11.1,38.9h17.2c8.5-10.6,8.2-24.9,8.8-38.9h18v38.9h14.7v-101h-14.7L371.5,68.3L371.5,68.3z M418.8,68.1h-28.1v11.1h28.1V68.1z M364.2,37.9h15v-12h38.1v12H432v-12h37.4V14.3H432V0.8h-14.7v13.5H379V0.8h-14.9v13.5h-36.8v11.5h36.8V37.9z M418.8,129.4H397v10.9h21.7V129.4z M469.6,79.2V68.1h-32V41.4h-14.9v98.9h41.8v-10.9h-27V79.2H469.6z M508.2,42.9v10.4h98.1V42.9h-41.8v-8.1H601V24.4h-36.6v-7h-14.2v7H514v10.4h36.1v8.1H508.2z M588.1,93c-1.8,2.9-3.8,6-6.2,8.6c-2.3-2.8-4.2-5.7-6-8.6h-16.2c5.9,11.5,16.3,26.3,27,34.6H608c-6.2-4.7-12.4-10.4-17.8-15.9c6.9-5.2,12.1-12,17-18.7H588.1z M506.7,131.5v10.7h103.1c9.7,0,16.2-4.8,16.2-14.3V15.9c0-6.2-5.8-13.2-14.2-13.2H506.7v10.7H607c2.1,0,4.2,1.8,4.2,4.4v109.6c0,2.8-2.3,4.1-4.6,4.1H506.7z M503,2.7c-7.4-0.1-14.2,5.8-14.3,13.2v111.3c0,8.3,6.5,14.8,14.3,15.1L503,2.7L503,2.7z M506.7,110.4h26.6c0.8-0.2,1.5-0.5,2.1-1v18.2h14.2V96.6c2-2.1,5.1-5.5,6.9-7.8H590c5.7,0.1,9.7-3.3,9.6-8.6V69.1c0-5.6-3.4-9.9-9.6-9.9h-66.5c-4.2-0.1-8.3,3.7-8.5,7.3v13c0,4.7,3.5,9.4,8.8,9.3h12.7C527.8,97.9,517.3,105,506.7,110.4L506.7,110.4L506.7,110.4z M532.3,78.4c-1.5,0-2.9-1.5-2.9-2.8v-3.7c0-1.5,1.5-2.4,2.8-2.4h50.2c1.5,0,2.8,1.1,2.8,2.6v3.6c0,1.3-0.8,2.8-2.6,2.8H532.3L532.3,78.4z M27,78.1v64.4H12.1V86.7H0c10.3-15.8,15.9-29.6,21.1-46.2h15C32.4,53.3,27.4,66,21.4,78.1H27z M2.1,37.7C11,26.5,17.7,13,23.2,0h15.7c-5.4,13-11.1,25.9-19.1,37.7L2.1,37.7z M46.7,142.5H30.4c11.8-19.2,14.4-42.1,12.9-66.5h14.5C58.5,98.6,57.4,123.1,46.7,142.5z M128.3,142.5c-3.9-6.2-6.9-12-9.8-18.5c-3.4,6.3-6.9,12.2-11.1,18.5H90.2c11.3-14.3,15.7-23.3,21.6-35.6C106.9,93.7,103.3,80,99.9,66h13.9c1.5,6.7,3.3,13.5,5.4,19.5c3.9-15.1,6-30.9,6.5-47.2h-12.4c-1.6,6.2-4.6,16.3-6.4,21.8H96.4v7.5H35.1V56.8h58.5c6.2-18.2,10.3-37.1,12.9-56.8h14.2c-1.1,8.5-2.9,17.9-5.1,26.8h28.6v11.5h-4.9c-2.1,23.4-5.2,46.7-13.2,67.8c5.1,12.8,11.6,24.6,19.1,36.3H128.3L128.3,142.5z M82,45.5H51.5c-6.8,0-11.3-4.7-11.3-11.4V7.8h12.6v22.9c0,1.6,1.8,3.4,2.9,3.4h4.4V0h12.9v34.2h4.6c1.3,0,2.6-1.5,2.6-2.9V7.4H93V35C93,41.4,88.2,45.5,82,45.5z M84.5,129.6c-6.6,3.7-13.7-0.8-13.7-8.1V76h14.4v36.8c0,1.8,1.5,2.9,3.1,2.1l12.1-6.5V121L84.5,129.6z"/>
<path d="M244.5,177.9c-3.2,0-5.5-1.4-5.9-4.3h2.6c0.3,1.6,1.6,2.7,3.3,2.7c1.2,0,2.6-0.5,2.6-1.9c0-3.7-8.1-3.4-8.2-8.1c0-3,3.2-4.3,5.9-4.2c2.8,0,5,1.6,5.7,4.1h-2.4c-0.5-1.6-1.7-2.8-3.4-2.7c-1.3,0-2.6,0.7-2.6,2c0,3.3,8.4,3.7,8.4,8C250.5,176.9,247.4,177.9,244.5,177.9z M255.3,162.4h3.7l5.3,10.4l5.2-10.4h3.6v15.2h-3.8v-9.9l-5,9.9h-1.5l-5.2-10v10h-2.4V162.4z M278.6,162.4h3.8v15.2h-3.8V162.4z M287.9,162.4h3.8v13.7h7.8v1.6h-11.6V162.4z M314.9,163.7h-7.7v5h6.4v1.3h-6.4v6h7.7v1.6h-11.4v-15.2h11.4V163.7z M331.1,170c0,6.3,7.6,8.2,10.3,2.7l1.6,1.2c-3.8,7-16,4.5-16.1-3.8c0-8.4,12.4-10.9,16.1-3.8l-1.6,1.1C338.6,161.9,331,163.7,331.1,170z M360.4,177.7h-3.8l-1.9-4.2h-5.9l-2,4.2h-2.6l7.5-15.6h1.6L360.4,177.7z M349.5,172.1h4.6l-2.3-4.9L349.5,172.1z M367.6,177.9c-3.2,0-5.5-1.4-5.9-4.3h2.6c0.3,1.6,1.6,2.7,3.3,2.7c1.2,0,2.6-0.5,2.6-1.9c0-3.7-8.1-3.4-8.2-8.1c0-3,3.2-4.3,5.9-4.2c2.8,0,5,1.6,5.7,4.1h-2.4c-0.5-1.6-1.7-2.8-3.4-2.7c-1.3,0-2.6,0.7-2.6,2c0,3.3,8.4,3.7,8.4,8C373.6,176.9,370.5,177.9,367.6,177.9z M390,162.4v1.3h-5.3v13.9h-3.8v-13.9h-5.3v-1.3H390z M392.7,162.4h3.8v13.7h7.8v1.6h-11.6V162.4z M418,163.7h-7.7v5h6.4v1.3h-6.4v6h7.7v1.6h-11.4v-15.2H418V163.7z"/>
<g fill="none" stroke="#FFF" stroke-width="0.7">
<path d="M225.6,169H9.1"/>
<path d="M626,169H426.3"/>
</g>
</svg>
      <div class="info">
        <div class="btn flex-c" @click="showCallDialog" data-aos="fade-down" data-aos-delay="100">
          <span class="flex-c">
            <font-awesome-icon icon="phone" />
            <span>{{info.phone}}</span>
          </span>
        </div>
        <div class="btn flex-c" @click="showMessengerDialog" data-aos="fade-down" data-aos-delay="200">
          <span class="flex-c">
            <font-awesome-icon :icon="['fab', 'facebook-messenger']" /><span>FB 諮詢</span>
          </span>
        </div>
        <a class="btn flex-c btfanpage" :href="info.fbLink" target="_blank" data-aos="fade-down" data-aos-delay="300">
          <span class="flex-c">
            <font-awesome-icon :icon="['fab', 'facebook-f']" /><span>前往粉絲專頁</span>
          </span>
        </a>
        <div class="addressall" data-aos="fade-down" data-aos-delay="400">
          <div class="address flex-c">接待中心：<br v-if="isMobile">{{info.address}}</div>
          <div class="google-btn flex-c" @click="showMapDialog">
            <span class="flex-c">
              <font-awesome-icon icon="map-marker-alt" /><span>導航 Google 地圖</span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title :visible.sync="isShowCallDialog" :width="isMobile ? '90%' : '500px'" :modal-append-to-body="false">
      <CallDialog :phone="info.phone" />
    </el-dialog>
    <el-dialog title :visible.sync="isShowMessengerDialog" :width="isMobile ? '90%' : '500px'" :modal-append-to-body="false">
      <MessengerDialog :messenger="info.fbMessage" />
    </el-dialog>
    <el-dialog title :visible.sync="isShowMapDialog" :width="isMobile ? '90%' : '500px'" :modal-append-to-body="false">
      <MapDialog :link="info.googleLink" :address="info.address" />
    </el-dialog>
  </div>
</template>

<script>
import info from '@/info'
import { isMobile, isTablet } from '@/utils'
import CallDialog from '@/components/Dialog/Call'
import MessengerDialog from '@/components/Dialog/Messenger'
import MapDialog from '@/components/Dialog/Map'
export default {
  name: 'contactInfo',
  components: {
    CallDialog,
    MessengerDialog,
    MapDialog,
  },
  data() {
    return {
      info,

      isMobile,
      isTablet,
      isShowCallDialog: false,
      isShowMessengerDialog: false,
      isShowMapDialog: false,
    }
  },
  methods: {
    showCallDialog() {
      // if (!this.isMobile) return
      this.isShowCallDialog = true
    },
    showMessengerDialog() {
      // if (!this.isMobile) return
      this.isShowMessengerDialog = true
    },

    showMapDialog() {
      // if (!this.isMobile) return
      this.isShowMapDialog = true
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/variableColor.scss';
@import '@/assets/style/variableDefault.scss';

.contact-info {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: space-between;
  position: relative;
  z-index: 3;
  width: 1200px;
  max-width: 100%;
  transform: translateY(0);
  margin: 5vw auto 2vw;
  padding: 3vw 0;
  line-height: 1.4;
  &::before{content: "";
  position: absolute;top: 0;left: 0;right: 0;bottom: 0;
  background: $contact_bg;
 display: block;z-index: 2;}
}


.imgl{position:absolute;top: 0;left: 0;transform-origin: 0% 0%;
img{position:absolute;}
> div{transform:scaleX(-1);}
.f1{width:size(169);top:size(-115);left:size(-250);
  transform:rotate(3deg);
  transform-origin: 90% 100%;
animation: an 3s -.5s ease-in-out infinite alternate-reverse;
}
.f2{width:size(360);top:size(500);left:size(-150);
  transform-origin: 0% 0%;
  transform: rotate(-90deg);
animation: an1 3s ease-in-out infinite alternate-reverse;}
.f3{width:size(90);top:size(-280);left:size(-190);
  transform: rotate(42deg);
  transform-origin: 90% 100%;
animation: an2 3s -.8s ease-in-out infinite alternate;}
.f5{width:size(310);top:size(320);left:size(-140);
  transform-origin: 0% 0%;
  transform: rotate(-110deg);
animation: an1 3s -.4s ease-in-out infinite alternate;}
.f6{width:size(250);top:size(240);left:size(-150);
  transform-origin: 0% 0%;
  transform:scaleX(-1) rotate(-166deg);
animation: an3 3s -.6s ease-in-out infinite alternate;}

}
.imgr{position:absolute;top: 50%;right: 0;transform-origin: 100% 50%;
img{position:absolute;}
.f1{width:size(212);top:size(-250);right:size(70);
  transform-origin: 90% 100%;
  transform:scaleX(-1) rotate(-47deg);
animation: an4 3s -.2s ease-in-out infinite alternate-reverse;}
.f2{width:size(332);top:size(-50);right:size(-170);
  transform-origin: 0% 0%;
  transform: rotate(-93deg);
animation: an1 3s -.4s ease-in-out infinite alternate;}
.f3{width:size(89);top:size(-500);right:size(80);
transform: rotate(60deg);
transform-origin: 90% 100%;
animation: an2 3s ease-in-out infinite alternate;}
.f4{width:size(370);top:size(-120);right:size(-240);
transform: rotate(-56deg);
transform-origin: 0% 0%;
animation: an5 3s ease-in-out infinite alternate;}
.f5{width:size(81);top:size(-320);right:size(70);
transform: rotate(100deg);
transform-origin: 90% 100%;
animation: an6 3s ease-in-out infinite alternate;}
}
@keyframes an{
  to{
    transform: rotate(0deg);
  }
}
@keyframes an1{
  to{
    transform:  rotate(-100deg);
  }
}
@keyframes an2{
  to{
    transform: rotate(50deg);
  }
}
@keyframes an3{
  to{
  transform:scaleX(-1) rotate(-168deg);
  }
}
@keyframes an4{
  to{
  transform:scaleX(-1) rotate(-50deg);
  }
}
@keyframes an5{
  to{
transform: rotate(-60deg);
  }
}
@keyframes an6{
  to{
transform: rotate(95deg);
  }
}





.logo {
  width: $contact_logo_pc_width;
  height: auto;
  // height:;
  margin: 1vw auto 3vw;
  padding: 0 0 0 0;
  fill: #FFF;
  position: relative;z-index: 3;
}
.info {
  width: 880px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  position: relative;z-index: 3;
}

.btn {
  width: 280px;
  height: 60px;
  font-size: 16px;
  margin-bottom: 20px;
  cursor: pointer;
  text-decoration: none;
  color: $contact_btn_color;
  background: $contact_btn_bg;
 // box-shadow: $contact_btn_border;
  border: $contact_btn_border;
  // border-radius: 60px ;
  transition: all 0.5s;
  position: relative;
  overflow: hidden;
  font-weight: 600;
  &.half {
    width: 49%;
  }
  svg {
    color: $contact_btn_icon;
    width: 24px;
    height: 24px;
    margin-right: 12px;
    transition: all 0.5s;
  }

  &:hover {
    background: $contact_btn_hover_bg;
    // background-image: url("../assets/img/contact_gold_button.png");
    color: $contact_btn_hover_color;
    box-shadow: none !important;

    svg {
      color: $contact_btn_hover_icon;
    }
  }
  &::before {
    content: '';
    width: 40%;
    height: 100%;
    display: block;
    background: #fff;
    position: absolute;
    -webkit-transform: skewX(-20deg);
    transform: skewX(-20deg);
    left: -10%;
    opacity: 0;
    top: 0;
    z-index: 5;
    transition: all 0.4s cubic-bezier(0.2, 0.95, 0.57, 0.99);
  }
  &:hover:before {
    opacity: 1;
    width: 90%;
    left: 140%;
  }
}
.addressall{
  width: 99%;
 // border-radius:60px ;
  background: #EEE;
}
.address {
  width:calc(100% - 280px);
  height: 60px;
  color: #040000;
  font-weight: bold;
  float: left;
  //box-shadow: $contact_btn_border;
  //border: $contact_btn_border;
}
.google-btn {
  width: 280px;
  height: 60px;
  font-size: 16px;
  cursor: pointer;
  position: relative;
  left: 1%;
  text-decoration: none;
  // border-top-right-radius: 60px;
  //border-bottom-right-radius: 60px;
  color: $contact_google_btn_color;
  background: $contact_google_btn_bg;
  background-position: center !important;
  border: $contact_btn_border;
  transition: all 0.5s;
 // border-radius:60px ;
  font-weight: 600;

  svg {
    color: $contact_google_btn_icon;
    width: 24px;
    height: 24px;
    margin-right: 12px;
    transition: all 0.5s;
  }

  &:hover {
    background: $contact_google_hover_btn_bg;
    color: $contact_google_hover_btn_color;

    svg {
      color: $contact_google_hover_btn_icon;
    }
  }
}

/* 平板尺寸 */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .contact-info {
    display: flex;
    width: 90% !important;
    height: 360px;
    padding: 60px 0 80px;

    .logo {
      width: $contact_logo_tablet_width;
    }
  }
}

/* 手機尺寸 */
@media only screen and (max-width: 767px) {
  .contact-info {
  //  background: $contact_bg_m;
    background-size: 250% auto;
    display: flex;
    width: 100%;
    //  max-width: 95%;
    height: auto;
    padding:0 5% 5% 5%;
    transform: none;
    // position: static;
    margin:43vw 0 0 0;

  }
.imgl{
.f1{
  width:19vw;top:-24vw;left:-60vw;
}
.f2{
  width: 30vw;top: 1vw;left: -23vw;
}
.f3{width: 9vw;
    top: -38vw;
    left: -45vw;}
.f5{
    width: 32vw;
    top: 16vw;
    left: -46vw;}
.f6{width: 26vw;
    top: 11.5vw;
    left: -39vw;}
}
.imgr{
    top:0;
> div{transform:rotate(-27deg);}
 .f3 {
    width: 9vw;
    top: -44vw;
    right: 31vw;
  }
  .f5 {
    width: 5vw;
    top: -25vw;
    right: 26vw;
  }
  .f2{
    width: 29vw;
    top: -4vw;
    right: 10vw;
  }
  .f4{
    width: 32vw;
    top: -11vw;
    right: 2vw;
  }
  .f1{
    width: 19vw;
    top: -28vw;
    right: 22vw;
  }
}

  .btn {
    &.half {
      width: 280px;
    }
    svg {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: calc(50% - 5em);
      margin-right: 0;
      + span {
        margin-left: 1.5em;
      }
    }
  }

  .info {
    width: 100%;
    justify-content: center;
    text-align: center;
    //margin-bottom: 40px;

    > * {
      margin-bottom: 12px;
      &.address {
        margin-bottom: 0;
      }
    }
  }

  .logo {
  margin: 15vw auto 10vw;
    left: auto;
    position: relative;
      width: $contact_logo_mobile_width;
  }
  .btn,
  .address,
  .google-btn {
    width: 100%;
  }
 // .google-btn {  }
  .addressall{
    width: 100%;
 //   border-radius: 30px;
  }
  .address {
    // width: 280px;
    padding: .9em 1em;
    text-align: justify;
    //font-size: 14px;
    height: auto;
  }

  .google-btn {
    margin-top: 15px;
    left: 0;
  }
}

@media only screen and (max-width: 321px) {
  .address {
    font-size: 14px;
  }
}
</style>
